import fileExtension from '../../../infrastructure/constants/fileExtension';
import SelectOption from '../../../infrastructure/types/SelectOption';
import IngestionMode from '../../../types/ingestion/IngestionMode';

const requiresCsvArguments = (fileType: string): boolean => {
    return (
        fileType === fileExtension.csv ||
        fileType === fileExtension.txt
    );
};

const getIngestionModeOptions = (): SelectOption[] => {

    let values = Object.values(IngestionMode);

    let options: SelectOption[] = [];

    values.forEach((x) => options.push({ text: x, value: x } as SelectOption));

    return options;
}

export { requiresCsvArguments, getIngestionModeOptions };
